module.exports = __webpack_public_path__ + "static/demo-53fda9e5c864fd3e340be50f15fde93c.jpeg";